var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("page-nav-bar", {
          attrs: {
            currentServiceName: "MoneyRoad",
            subNavTitle: "Application Settings",
            returnPreviousPage: false,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 offset-md-3" }, [
              _c("div", { staticClass: "panel21 panel-default" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("ul", [
                  _c("div", { staticClass: "accordion-item accordionForm" }, [
                    _c(
                      "a",
                      {
                        staticClass: "item-content item-link",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.rotateChevron($event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "item-inner",
                            class: _vm.colorBottomButton,
                          },
                          [_vm._m(1)]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "accordion-item-content" }, [
                      _c("div", { staticClass: "form-group " }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v("Generate Bank Transfer Order"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxPain001",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.pain001 },
                              on: { change: _vm.switchPain001 },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group " }, [
                        _c(
                          "label",
                          { staticClass: "col-form-label labelCheckbox" },
                          [_vm._v("Generate Instant Payment")]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxPacs008",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.pacs008 },
                              on: { change: _vm.changeSwitchPacs008 },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group " }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v("Send Direct Payment with decision"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxDecisionCreancier",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.decision_creancier },
                              on: { change: _vm.changeSwitchDecisionCreancier },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group " }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v(_vm._s(_vm.$t("settings.activate_OCR"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxOcrActivation",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.ocrActivation },
                              on: { change: _vm.changeSwitchOcrActivation },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group " }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v("Notify receiver by e-mail"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxEmailRcv",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.emailForRcv },
                              on: { change: _vm.switchEmailRcv },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("ul", [
                  _c("div", { staticClass: "accordion-item accordionForm" }, [
                    _c(
                      "a",
                      {
                        staticClass: "item-content item-link",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.rotateChevron($event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "item-inner",
                            class: _vm.colorBottomButton,
                          },
                          [_vm._m(2)]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "accordion-item-content" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v("Always Accept Direct Payments"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-switch",
                            class: _vm.labelSwitchColorClass,
                          },
                          [
                            _c("input", {
                              staticClass: "checkboxAutoAcceptPayment",
                              attrs: { type: "checkbox" },
                              domProps: { value: _vm.auto_accept_payment },
                              on: { change: _vm.changeSwitchAutoAcceptPayment },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v("Highest Amount"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _vm._v(_vm._s(_vm.max_amount)),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.max_amount,
                              expression: "max_amount",
                            },
                          ],
                          staticClass: "range-slider-streammind",
                          class: _vm.sliderColorClass,
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "150000",
                            value: "0",
                            step: "500",
                          },
                          domProps: { value: _vm.max_amount },
                          on: {
                            __r: function ($event) {
                              _vm.max_amount = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-md-2 offset-md-7",
                class: _vm.colorBottomButton,
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "button-action firstButtonMarginTop",
                    attrs: { round: "" },
                    on: { click: _vm.changeApplicationSettings },
                  },
                  [
                    _c("i", { staticClass: "icon fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Save")]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "toolbarPageBottomBlank" }),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "content-block labelAccordionForm" }, [
        _c("img", {
          staticClass: "formIcon",
          attrs: {
            src: require("../../assets/static/images/icons/gearwheels.png"),
          },
        }),
        _vm._v("\n                    SETTING\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group row justify-content-start" }, [
      _c("div", { staticClass: "item-title createInvoiceBand col-sm-auto" }, [
        _vm._v(
          "\n                          GENERAL\n                          "
        ),
        _c("i", { staticClass: "f7-icons formChevron" }, [
          _vm._v("chevron_right"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group row justify-content-start" }, [
      _c("div", { staticClass: "item-title createInvoiceBand col-sm-auto" }, [
        _vm._v("\n                          OTHER\n                          "),
        _c("i", { staticClass: "f7-icons formChevron" }, [
          _vm._v("chevron_right"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }